/** Auth configuration — single place for login-related constants. */

export const clerkEnabled = Boolean(process.env.VUE_APP_CLERK_PUBLISHABLE_KEY)

export const authRoutes = Object.freeze({
  home: '/',
  ssoCallback: '/sso-callback',
  mailLogin: '/login',
  calendar: '/kalender',
  myBookings: '/mine-bookinger'
})

export const authApi = Object.freeze({
  clerkBridge: '/auth-clerk.php',
  passwordLogin: '/loginUserPass.php',
  logout: '/user.php?mode=logout',
  currentUser: '/user.php'
})

export function apiUrl(path) {
  return (process.env.VUE_APP_API_ROOT || '/api') + path
}

export function absoluteAppUrl(path) {
  return window.location.origin + path
}
